import { render, staticRenderFns } from "./DisplayStoreItemsList3.vue?vue&type=template&id=5dc0984c&"
import script from "./DisplayStoreItemsList3.vue?vue&type=script&lang=js&"
export * from "./DisplayStoreItemsList3.vue?vue&type=script&lang=js&"
import style0 from "./DisplayStoreItemsList3.vue?vue&type=style&index=0&id=5dc0984c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports